import { Component, OnInit, OnDestroy } from "@angular/core";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

import { AuthService } from "../../services/auth.service";
import { AppUserService } from "../../services/appuser.service";
import { IUser } from "../../interfaces/ilogin";

@Component({
    selector: "deloittedpass",
    templateUrl: "./deloittead.component.html",
    standalone: false
})
export class DeloitteDpassComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>();

    constructor(private router: Router, private activatedRoute: ActivatedRoute, private authService: AuthService, private appUserService: AppUserService) {

    }

    ngOnInit(): void {
        this.appUserService.getUser()
            .pipe(takeUntil(this.destroy$))
            .subscribe((user: IUser) => {
                this.authService.user = user;
                this.authService.businessFunctions = user.businessFunctions;

                if (user.businessFunctions.length > 1) {
                    this.router.navigate(["/businessfunctionselector"]);
                } else {
                    // the user only belongs to one business function so set it
                    // and redirect to the home page
                    this.authService.businessFunction = user.businessFunctions[0];
                    this.router.navigate([`${user.businessFunctions[0].defaultRoute}`]);
                }
            }, err => {
                if (err.status === 401) {
                    this.router.navigate(["/unauthorized"]);
                }
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}